const Poll = {

    // PAGE HEADER
    "poll": "Poll",

    // FIELDS
    "premise": "Premise",
    "title": "Title",
    "description": "Description",
    "start_date": "Start Date",
    "end_date": "End Date",
    "allow_result_visibility": "Allow Result Visibility",
    "status": "Status",
    "search": "Search",

    // POLL OPTIONS
    "poll_options": "Poll Options",
    "option": "Option",
    "yes": "Yes",
    "no": "No",
    "votes": "Votes",
    "total_votes": "Total Votes",
    "total_submissions": "Total Submissions",
    "poll_results": "Poll Results",
    "created_at": "Created At",
    "no_description": "No description provided.",
    "no_options": "No poll options found.",
    "no_results": "No voting results available yet.",
    "load_error": "Something went wrong. Unable to load poll details.",

    // TABLE HEADERS
    "table_title": "TITLE",
    "table_premise": "PREMISE",
    "table_start_date": "START DATE",
    "table_end_date": "END DATE",
    "table_total_options": "TOTAL OPTIONS",
    "table_allow_result_visibility": "ALLOW RESULT VISIBILITY",
    "table_status": "STATUS",

    // ERRORS
    "error_premise": "Select Premise",
    "error_title": "Enter Title",
    "error_start_date": "Select Start Date",
    "error_end_date": "Select End Date",
    "error_end_date_before_start": "End Date cannot be earlier than Start Date",
    "error_status": "Select Status",
    "error_option": "Enter Option",
    "error_min_options": "At least 2 poll options are required",

}

export default Poll;